// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-report .section-title[data-v-2fdb3e1f]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:8px}.table-report .section-title h3[data-v-2fdb3e1f]{margin-bottom:0}.table-report .section-title span[data-v-2fdb3e1f]{margin:auto 0 auto auto;padding:4px 8px;background-color:#303034;color:#fff;border-radius:4px}", ""]);
// Exports
module.exports = exports;
